<template>
  <v-container fluid>
    <v-tabs
        color="transparent"
        v-model="tab"
        show-arrows
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab v-for="tabItem in tabs" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item v-for="(item, index) in 3" :key="'item' + index">
          <v-container fluid grid-list-lg >
            <v-layout justify-space-around="" row wrap v-if="tab === 0">
              <v-flex>
                <v-card>
                  <v-card-text>
                    <div>{{ $t('name') }}: {{userData && userData.name}}</div>
                    <div>{{ $t('email') }}: {{userData && userData.email}}</div>
                    <div v-if="isOrganization || isWarehouse">
                      {{ $t(isOrganization ? 'organization' : 'warehouse') }}: {{ (isWarehouse && warehouseName) || (isOrganization && organizationName) }}
                    </div>
                    <div v-if="isOrganization">{{ $t('invitationCode') }}: <span id="invCode">{{$store.getters.tenant.invitationCode}}</span></div>
                    <div v-if="isModeLabel">
                      apiKey: {{userData && userData.apiKey}}
                      <v-icon color="primary" @click.stop="copyToClipboard(userData.apiKey)">content_copy</v-icon>
                    </div>
                    <br/>
                    <div>
                      <v-btn v-if="isOrganization" color="primary" @click.stop="generateInvitationCode" id="genCode">{{ $t('generateInvitationCode') }}</v-btn>
                      <v-btn v-if="!isOrganization && !isWarehouse && isOfferAndTaskAvailable" color="primary" @click.stop="editApplyFunc" id="joinOrg">{{ $t('joinAnOrganization') }}</v-btn>
                      <v-btn color="secondary" @click.stop="resetPassword">{{ $t('resetPassword') }}</v-btn>
                    </div>
                    <br/>
                    <v-layout justify-space-between><v-flex><a @click.stop="suggestionDialog = true">{{ $t('suggestion?') }}</a></v-flex><v-spacer></v-spacer><v-flex class="text-xs-right">&copy;2018 Version: {{$store.getters.version}}</v-flex></v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex v-if="!isOrganization && !isWarehouse && isOfferAndTaskAvailable">
                <v-layout justify-start align-baseline>
                  <v-flex class="success--text caption"><span class="realtime-border px-1">{{ $t('realTIME') }}</span></v-flex>
                </v-layout>
                <v-data-table
                  :headers="headers"
                  :items="tenants"
                  hide-actions
                  class="elevation-1"
                  label="Organizations"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.tenantName }}</td>
                    <td>{{ props.item.status }}</td>
                    <td class="text-xs-center">
                      <v-layout row lg3>
                        <v-flex v-if="props.item.requestID"><v-btn color="primary" flat @click.stop="cancelRequest(props.item.requestID)">{{ $t('cancel') }}</v-btn></v-flex>
                        <v-flex v-else>
                          <LoaderButton
                            flat
                            :buttonText="$t('unsubscribe')"
                            :promiseAwait="unsubscribeOrg"
                            :promiseItem="props.item"/>
                        </v-flex>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout v-if="tab === 1 && index === 1 && !isOrganization && !isWarehouse && isOfferAndTaskAvailable" column="">
            <v-layout justify-space-between>
              <v-flex><v-btn color="primary" @click.stop="addAddressFunc" id="addSelfAddress">{{ $t('addAnAddress') }}</v-btn></v-flex>
              <v-flex xs8 md3>
                <v-text-field
                  append-icon="filter_list"
                  :label="$t('search')"
                  single-line
                  hide-details
                  v-model="filter"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers"
              :items="sites"
              item-key="siteName"
              :search="filter"
              class="elevation-2 myDense"
              :pagination.sync="pagination">
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.siteName }}</td>
                <td class="text-xs-left">{{ props.item.address1 }}</td>
                <td class="text-xs-left">{{ props.item.address2 }}</td>
                <td class="text-xs-left">{{ props.item.state }}</td>
                <td class="text-xs-left">{{ props.item.city }}</td>
                <td class="text-xs-left">{{ props.item.zip }}</td>
                <td class="text-xs-center">
                  <v-layout>
                    <v-flex><v-btn dark color="primary" flat @click.stop="editAddressFunc(props.item)">{{ $t('edit') }}</v-btn></v-flex>
                    <v-flex><v-btn dark color="primary" flat @click.stop="deleteSite(props.item)">{{ $t('delete') }}</v-btn></v-flex>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-layout>
          <v-layout v-if="tab === 2 && !isOrganization && !isWarehouse && isOfferAndTaskAvailable">
            <PaymentMethods />
          </v-layout>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <FormSubmitPopup
      :title="$t('joinAnOrganization')"
      v-model="editApply"
      @popupClose="editApply = false"
      :rightButtonText="$t('apply')"
      :rightMethod="joinSubmitted"
      small
    >
      <template v-slot:input>
        <v-layout>
          <v-text-field
            :label="$t('invitationCode')"
            single-line
            v-model="requestCode"
          ></v-text-field>
        </v-layout>
        <v-layout>
          <v-text-field
            :label="$t('note')"
            single-line
            v-model="note"
          ></v-text-field>
        </v-layout>
      </template>
    </FormSubmitPopup>
    <EditAddress
      v-model="addAddress"
      v-if="addAddress"
      :actionFunc="addressSubmitted"
      :siteNames="siteNames"></EditAddress>
    <EditAddress
      v-model="editAddress"
      v-if="editAddress"
      :address="addressInEdit"
      editMode
      :siteNames="siteNames"
      :actionFunc="editAddressSubmitted"
      :checkDistribution="() => $store.dispatch('checkUserDistribution', addressInEdit)"/>
    <SuggestionsPopup
      v-model="suggestionDialog"
      v-if="suggestionDialog"
      :actionMethod="SubmitSuggestion"
      :email="suggestion.email"
      :name="suggestion.name"
    >
      <template v-slot:inputText>
        <div>
          <v-flex>{{ $t('profileTips1') }}</v-flex>
          <v-flex>{{ $t('profileTips2') }}</v-flex>
          <br />{{ $t('profileContact') }}
          <br />QQ: 3372450933
          <br />
          <br />{{ $t('or') }}
          <br />
          <br />
        </div>
      </template>
    </SuggestionsPopup>
  </v-container>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import EditAddress from './EditAddress'
import PaymentMethods from './PaymentMethods'
import SuggestionsPopup from './SuggestionsPopup'
import LoaderButton from './LoaderButton'
import {allModules, thirdPartModuleConfig} from '../../config/moduleConfig'
import { mapGetters } from 'vuex'
import { copyText } from '@/utils/tools'

export default {
  name: 'Profile',
  components: {
    FormSubmitPopup,
    EditAddress,
    PaymentMethods,
    SuggestionsPopup,
    LoaderButton
  },
  data () {
    return {
      tab: 0,
      editApply: false,
      editAddress: false,
      addAddress: false,
      suggestionDialog: false,
      addressInEdit: {},
      pagination: {},
      filter: '',
      suggestion: {},
      requestCode: '',
      note: ''
    }
  },
  mounted () {
    if (!this.isOrganization) {
      this.$store.dispatch('getTenantRequested')
      this.$store.dispatch('getUserSites')
    }
    this.suggestion = {
      email: this.$store.getters.userExtra.email,
      name: this.$store.getters.userExtra.name
    }
  },
  beforeDestroy () {
    if (!this.isOrganization) {
      this.$store.dispatch('clearTenantRequested')
    }
  },
  computed: {
    ...mapGetters(['isModeLabel']),
    tabs () {
      return this.isOrganization || this.isWarehouse || !this.isOfferAndTaskAvailable ? [this.$t('basicInfo')] : [this.$t('basicInfo'), this.$t('selfStorage'), this.$t('paymentMethods')]
    },
    headers () {
      return this.tab === 1 ? [
        { text: this.$t('siteName'), value: 'siteName', align: 'left', sortable: false },
        { text: `${this.$t('address')}1`, value: 'address1', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('address2'), value: 'address2', align: 'left', sortable: false },
        { text: this.$t('state'), value: 'state', align: 'left', sortable: false },
        { text: this.$t('city'), value: 'city', align: 'left', sortable: false },
        { text: this.$t('zip'), value: 'zip', align: 'left', sortable: false },
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '10%' }
      ] : [
        { text: this.$t('organization'), align: 'left', sortable: false, value: 'tenantName' },
        { text: this.$t('status'), align: 'left', sortable: false, value: 'status' },
        { text: this.$t('actions'), value: 'action', align: 'center', sortable: false, width: '8%' }
      ]
    },
    userData () {
      return this.mainAccount || this.$store.getters.userExtra
    },
    mainAccount () {
      return this.$store.getters.mainAccount
    },
    tenants () {
      return this.$store.getters.tenantsForUser
    },
    sites () {
      return this.$store.getters.sites
    },
    siteNames () {
      let names = new Set(this.sites.map(item => item.siteName))
      names.delete(this.addressInEdit.siteName)
      return names
    },
    isOrganization () {
      return !!this.$store.getters.activeOrganization
    },
    isWarehouse () {
      return !!this.$store.getters.activeWarehouse
    },
    warehouseName () {
      return this.$store.getters.warehouseLimitedInfo?.warehouseName || ''
    },
    organizationName () {
      return this.$store.getters.tenantLimitedInfo?.name || this.$store.getters.tenant?.name || ''
    },
    env () {
      return this.$store.getters.env
    },
    availableModule () {
      return thirdPartModuleConfig[this.env] || allModules
    },
    isOfferAndTaskAvailable () {
      return this.availableModule.includes('offerAndTask')
    }
  },
  methods: {
    copyToClipboard (text) {
      let errorMsg = copyText(text)
      if (!errorMsg) return this.$store.dispatch('showToast', {info: this.$t('success'), level: 'success'})
      this.$store.dispatch('showToast', {info: errorMsg.message, level: 'error'})
    },
    joinSubmitted () {
      const {requestCode, note} = this
      return this.dispatchAndToast(this.$store.dispatch('requestJoin', {requestCode, note}), 'Join organization')
    },
    dispatchAndToast (promise, actionText) {
      return promise
        .catch(error => {
          this.$store.dispatch('showToast', {info: error.message})
          throw error
        })
    },
    addressSubmitted (payload) {
      this.dispatchAndToast(this.$store.dispatch('addNurseAddress', payload), 'Address added success.')
    },
    editAddressSubmitted (newAddress, oldAddress) {
      let payload = { newAddress, oldAddress }
      this.dispatchAndToast(this.$store.dispatch('editNurseAddress', payload), 'Address edit.')
    },
    deleteSite (index) {
      if (confirm('Are you sure to delete this site?')) {
        this.dispatchAndToast(this.$store.dispatch('deleteNurseAddress', index), 'Address delete.')
      }
    },
    cancelRequest (requestID) {
      this.$store.dispatch('cancelRequest', requestID)
    },
    editApplyFunc () {
      this.editApply = true
    },
    editAddressFunc (item) {
      this.addressInEdit = {...item}
      this.editAddress = true
    },
    addAddressFunc () {
      this.addAddress = true
    },
    resetPassword () {
      if (confirm(this.$t('confirmResetPassword'))) {
        this.dispatchAndToast(this.$store.dispatch('sendPasswordResetEmail', this.$store.getters.userExtra.email), 'An reset email has been sent')
          .then(res => {
            this.$store.dispatch('showToast', {info: this.$t('resetPasswordToast'), level: 'success'})
          })
          .catch(error => {
            this.$store.dispatch('showToast', {info: error.message, level: 'error'})
            throw error
          })
      }
    },
    generateInvitationCode () {
      this.$store.dispatch('generateInvitationCode')
    },
    SubmitSuggestion (payload) {
      this.$store.dispatch('sendSuggestion', payload)
    },
    unsubscribeOrg (item) {
      if (!confirm(this.$t('confirmUnsubscribeTenantName', { tenantName: item.tenantName }))) return Promise.resolve('')
      return this.$store.dispatch('unsubscribleOrg', item)
        .catch(error => {
          console.error(error)
          this.$store.dispatch('showToast', {info: error.message})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue